import "@/App.css";
import "@/index.css";
import Climaterio from "@/pages/Climaterio";

function App() {
  return (
    <div className="App ph-no-capture" data-ph-no-capture>
      <Climaterio />
    </div>
  );
}

export default App;
